import React, { useCallback, useEffect, useMemo } from 'react';

import { downloadExcel, downloadSettingExcel } from "src/utils/blob/blobUtil";

import { SysCodeDto } from 'src/dtos/code/sysCodeDto';

import { defaultKSK2090_R01Filter, KSK2090_R01Filter, useKSK2090_R01Store } from './Store_KSK2090_R01';
import useFetchActionbarAuth from 'src/hooks/useFetchActionbarAuth';
import { Tab } from 'src/store/useUiuxStore';
import { useLoadingSpinnerStore } from 'src/store/util/loadingSpinnerUtil';
import { showError, showSuccess, ShowSuccessFetch, showWarning } from 'src/utils/toast/toastUtil';

import { deleteKSK2090_R01, downloadExcel_KSK2090_R01, getKSK2090_R01AllCount, getKSK2090_R01DetailList, getKSK2090_R01List, patchKSK2090_R01, postKSK2090_R01, printKSK2090_R01 } from "./Api_KSK2090_R01";
import { defaultKSK2090_R01DetailDto, defaultKSK2090_R01HeaderDto, KSK2090_R01DetailDto, KSK2090_R01Dto, KSK2090_R01HeaderDto } from './Dto_KSK2090_R01';
import { AgGridReact } from 'ag-grid-react';
import { fetchDataSetHandler, fetchFilterConfig, gridRefSelectedRowHandler } from 'src/utils/grid/GridHandlerContent';
import { CompanyDto } from 'src/dtos/company/companyDto';
import { useCommonCodeStore } from 'src/store/useCommonCodeStore';
import { validateString } from 'src/utils/string/stringUtil';
import { json } from 'stream/consumers';

interface Props {
	gridRef: React.RefObject<AgGridReact<KSK2090_R01HeaderDto> | null>;
	detailGridRef: React.RefObject<AgGridReact<KSK2090_R01DetailDto> | null>;

	tabList: Tab[] | undefined;
	setMessage: (message: string) => void;

	containerRef: React.RefObject<HTMLDivElement | null>;
	isResizing: React.MutableRefObject<boolean>;
	
}



export const Content_KSK2090_R01 = (props: Props) => {

	const {
		gridRef, detailGridRef,
		tabList, setMessage,
		containerRef,
		isResizing,
	} = props;

	const { layerList, compCdList } = useCommonCodeStore();

	
	const {
		KSK2090_R01Filter, setKSK2090_R01Filter,
		KSK2090_R01PastFilter, setKSK2090_R01PastFilter,
		KSK2090_R01List, setKSK2090_R01List,
		editKSK2090_R01, setEditKSK2090_R01,
		selectedKSK2090_R01, setSelectedKSK2090_R01, 
		deletedKSK2090_R01DetailList, setDeletedKSK2090_R01DetailList, addDeletedKSK2090_R01DetailList, removeDeletedKSK2090_R01DetailList, 
		selectedKSK2090_R01DetailList, setSelectedKSK2090_R01DetailList, addSelectedKSK2090_R01DetailList, removeSelectedKSK2090_R01DetailList,
		KSK2090_R01DetailList, setKSK2090_R01DetailList, insertKSK2090_R01DetailList,
		editKSK2090_R01Detail, setEditKSK2090_R01Detail,
		originalKSK2090_R01DetailList, setOriginalKSK2090_R01DetailList,
		allCount, setAllCount,
		initData, 
	} = useKSK2090_R01Store();
	const { setLoadingSpinner } = useLoadingSpinnerStore();

	useFetchActionbarAuth("KSK2090_R01");

	const handlePrintClick = async () => {
		if (!selectedKSK2090_R01 || !selectedKSK2090_R01.prntItemcd) {
				showWarning("출력할 품목정보를 선택하세요.");
				setMessage("출력할 품목정보를 선택하세요.");
				return;
			}
			try {
				await printKSK2090_R01(selectedKSK2090_R01.prntItemcd);
			} catch (error) {
			setMessage("PDF 출력 중 오류가 발생했습니다.");
			}
		};
	

	const handleExcelClick = useCallback(async () => {
		if (!selectedKSK2090_R01) {
			showWarning("선택된 품목정보가 없습니다.");
			return;
		}
		setLoadingSpinner(true);

		const response = await downloadExcel_KSK2090_R01('', selectedKSK2090_R01.prntItemcd, KSK2090_R01List.length ?? 0);

		downloadSettingExcel({ responseData: response.data.data, fileName: '실장좌표정보 등록-excel.xlsx' });

		setLoadingSpinner(false);
	}, [selectedKSK2090_R01])

	const getParams = (filter: KSK2090_R01Filter) => {
		const params: Partial<KSK2090_R01Filter> = {
			prntItemcd: filter.prntItemcd || undefined,
		};
		return params;
	}

	const renewalAllCount = useCallback(async () => {
		const response = await getKSK2090_R01AllCount(getParams(KSK2090_R01Filter));
		setAllCount(response.data.data);
		return response.data.data;
	}, [KSK2090_R01Filter, setAllCount]);

	const fetchData = useCallback(async () => {
		setLoadingSpinner(true);		
	
		const responseData = (await getKSK2090_R01List(
			'search',
			getParams(KSK2090_R01Filter),
			KSK2090_R01List.length ?? 0
		));


		let newList = [...responseData.data.data ] as KSK2090_R01HeaderDto[];
		setKSK2090_R01List(newList);

		const processAllCount = await renewalAllCount();
		if (newList && newList.length > 0) {
			gridRefSelectedRowHandler(
				gridRef,
				setSelectedKSK2090_R01,
				() => true,// () => !responseData.find(value => value.salBillNo === selectedKSK2090_R01?.salBillNo)
			);
			setKSK2090_R01PastFilter(KSK2090_R01Filter);
			ShowSuccessFetch(setMessage, `조회가 완료되었습니다. (총 ${newList.length}/${processAllCount}건)`);
		}else {
			showWarning('데이터가 없습니다.');
			setSelectedKSK2090_R01(undefined);
			setKSK2090_R01List([]);
			setKSK2090_R01DetailList([]); 
			setDeletedKSK2090_R01DetailList([]);
			setSelectedKSK2090_R01DetailList([]);
			setOriginalKSK2090_R01DetailList([]);
		}
		setLoadingSpinner(false);
		return responseData;
	}, [KSK2090_R01Filter, KSK2090_R01List, setKSK2090_R01List, setKSK2090_R01PastFilter, setSelectedKSK2090_R01, selectedKSK2090_R01])

	

	//신규 행 추가시 기본적으로 세팅할 데이터를 정하고 생성
	const defaultKSK2090_R01DetailRow = useMemo(() => {

		return {
			...defaultKSK2090_R01DetailDto,
			prntItemcd: selectedKSK2090_R01?.prntItemcd || '',
			inserted: true,
			topBottom: layerList[0]?.minorCd || '',
		}
	}, [defaultKSK2090_R01DetailDto, selectedKSK2090_R01]);
	
	
	const fetchDetailList = useCallback(async (prntItemcd: string) => {

		if(!prntItemcd || !KSK2090_R01Filter.prntItemnm) {
			showWarning('모품목코드를 선택하세요.');
			return;
		}

		const responseData = (await getKSK2090_R01DetailList(prntItemcd)).data.data;
		if(responseData && responseData.length > 0){
			setKSK2090_R01DetailList(
				responseData.map((value: any, idx: any) => ({
					...value,
					valueIndex: value.valueIndex ?? idx + 1,
					orderIndex: value.orderIndex ?? idx + 1,
					orderIndexSeq: value.orderIndexSeq ?? 0,
				})
			));
			setOriginalKSK2090_R01DetailList(responseData);
			detailGridRef.current?.api.ensureIndexVisible(0, 'top');
			setMessage(`${KSK2090_R01Filter.prntItemnm}의 실장좌표정보 ${responseData.length}건을 조회하였습니다.`);
			setTimeout(() => setMessage(""), 5000);
		}else{
			showWarning('품목코드에 해당하는 실장좌표정보가 없습니다.');
			setKSK2090_R01DetailList([]);
			// 행추가 안함
			// insertKSK2090_R01DetailList([{ ...defaultKSK2090_R01DetailRow, orderIndex: responseData.length + 1, orderIndexSeq: 0, inserted: true }]);
		}
	}, [selectedKSK2090_R01, KSK2090_R01DetailList, KSK2090_R01Filter])
	
	const initContainerData = useCallback(() => {
		initData();
		removeDeletedKSK2090_R01DetailList();
		removeSelectedKSK2090_R01DetailList();
		setEditKSK2090_R01({
			...defaultKSK2090_R01HeaderDto,
		})
	}, [compCdList, selectedKSK2090_R01])

	const handleDeleteClick = useCallback(() => {

		if (deletedKSK2090_R01DetailList.length > 0) {
			// 삭제 표시된 행이 있으면 전체 복구
			removeDeletedKSK2090_R01DetailList(deletedKSK2090_R01DetailList);
			removeSelectedKSK2090_R01DetailList();
			setKSK2090_R01DetailList([...KSK2090_R01DetailList]);
		} else if (selectedKSK2090_R01DetailList.length > 0) {
			addDeletedKSK2090_R01DetailList(selectedKSK2090_R01DetailList);
			removeSelectedKSK2090_R01DetailList(selectedKSK2090_R01DetailList);
		}
	}, [selectedKSK2090_R01DetailList, 
		deletedKSK2090_R01DetailList,
		addDeletedKSK2090_R01DetailList,
		removeDeletedKSK2090_R01DetailList,
		removeSelectedKSK2090_R01DetailList,
		setKSK2090_R01DetailList,
		KSK2090_R01DetailList]);
	
	const handleCreateClick = () => {
		setSelectedKSK2090_R01(undefined);
		setEditKSK2090_R01({
			...defaultKSK2090_R01HeaderDto
		})
		setKSK2090_R01DetailList([{...defaultKSK2090_R01DetailRow, inserted: true}]);
		setDeletedKSK2090_R01DetailList([]);
		setSelectedKSK2090_R01DetailList([]);
		setOriginalKSK2090_R01DetailList([]);
	}

	const validateInsertData = (filter: KSK2090_R01Filter) => {

		if(!validateString(filter.prntItemcd)) {
			showWarning('품목코드가 없습니다.');
			return false;
		}
		
		return true;
	}

	const handleSaveClick = useCallback(async () => {

		// 신규 사용자 처리
		const insertedList: KSK2090_R01DetailDto[] = KSK2090_R01DetailList.filter(row => 
			!deletedKSK2090_R01DetailList.includes(row.valueIndex.toString()) && 
			row.inserted === true
		);

		const modifiedList : KSK2090_R01DetailDto[] = KSK2090_R01DetailList.filter(row => 
			!deletedKSK2090_R01DetailList.includes(row.valueIndex.toString()) && 
			row.isModified && !row.inserted
		);
		
        // 수정 사용자 유효성 검증
		let seenMenuSet = new Set<string>();
		let valid = true;
		modifiedList.forEach((value) => {
			let index = KSK2090_R01DetailList.findIndex(Order => Order.coordinateCd === value.coordinateCd);
			if(!validateInsertData(KSK2090_R01Filter)) valid = false;
			seenMenuSet.add(value.coordinateCd);
		});
		if(!valid) { return; }
        // 신규 사용자 유효성 검증
		seenMenuSet = new Set<string>();
		valid = true;
		insertedList.forEach((value) => {
			let index = KSK2090_R01DetailList.findIndex(Order => Order.coordinateCd === value.coordinateCd);
			if(!validateInsertData(KSK2090_R01Filter)) valid = false;
			seenMenuSet.add(value.coordinateCd);
		});
		if(!valid) { return; }

		const deleteStringList = deletedKSK2090_R01DetailList.map(item => item.toString());
		//마감여부가 Y인 작업지시는 삭제 불가
		const deleteTargetList = KSK2090_R01DetailList.filter(item => 
			deleteStringList.includes(item.valueIndex.toString())
		);

		const [insertedResponse, modifiedResponse, deleteResponse] = await Promise.all([
			insertedList.length > 0 ? postKSK2090_R01(insertedList) : Promise.resolve(),
			modifiedList.length > 0 ? patchKSK2090_R01(modifiedList) : Promise.resolve(),
			deleteTargetList.length > 0 ? Promise.all(deleteTargetList.map(value =>  deleteKSK2090_R01(value.coordinateCd) )) : Promise.resolve()
		]);

		if(insertedResponse?.data.successFlag || modifiedResponse?.data.successFlag) {
			showSuccess('피더정보 저장이 완료되었습니다.');
			setMessage('피더정보 저장이 완료되었습니다.');
			setTimeout(() => { setMessage(''); }, 5000);
		} else if(deleteResponse) {
			showSuccess('피더정보 삭제가 완료되었습니다.');
			setMessage('피더정보 삭제가 완료되었습니다.');
		}
		setTimeout(() => { setMessage(''); }, 5000);

		setKSK2090_R01DetailList([]);
		setDeletedKSK2090_R01DetailList([]);
		setSelectedKSK2090_R01DetailList([]);
		setOriginalKSK2090_R01DetailList([]);

		fetchDetailList(KSK2090_R01Filter.prntItemcd!);

	}, [KSK2090_R01Filter, KSK2090_R01DetailList, deletedKSK2090_R01DetailList, originalKSK2090_R01DetailList, selectedKSK2090_R01]);

	// 발주내역 상세조회
	useEffect(() => {
	
		if (selectedKSK2090_R01) {
			fetchDetailList(selectedKSK2090_R01.prntItemcd!);
		}
	}, [selectedKSK2090_R01])

	useEffect(() => {
		if (selectedKSK2090_R01 && KSK2090_R01DetailList.length === 0) {
			insertKSK2090_R01DetailList([{ ...defaultKSK2090_R01DetailRow, inserted: true }]);
		}
	}, [selectedKSK2090_R01, KSK2090_R01DetailList])
	
	return {
		handlePrintClick,
		handleExcelClick,
		// fetchData,
		defaultKSK2090_R01DetailRow,
		fetchDetailList,
		initContainerData,
		handleDeleteClick,
		handleCreateClick,
		handleSaveClick,
	};
}
